import React from 'react';

import ProductChanges from '../components/product/product-changes';

class ProductChangesPage extends React.Component {

  render() {
    return (
      <div>
        <ProductChanges/>
      </div>
    )
  }
}

export default ProductChangesPage;


// WEBPACK FOOTER //
// ./src/containers/product-changes.js